import React from "react";
import PropTypes from "prop-types";
import Svg from 'react-inlinesvg';
import { Link } from "@tanstack/react-router";

const selectedStyle = {
  color: '#c9a44d',
  borderBottom: '1px solid',
  paddingBottom: '10px'
};

class CustomNavItem extends React.Component {

  render() {
    const { item } = this.props;
    return (
      <li>
        {
          (item.tag === 'a') ? (
            <a href={item.to} target='_blank' rel="noopener noreferrer">
              {item.icon && (
                <div className="d-inline-block item-icon-wrapper">
                  <Svg src={require('../../images/icons/' + item.icon)} />
                </div>
              )}
              {item.title && item.title}
            </a>
          ) : (
            <Link
              to={item.to}
              activeOptions={{ exact: Boolean(item.exact) }}
              activeProps={{
                className: "nav-link active",
              }}
              inactiveProps={{
                className: "nav-link",
              }}
            >
              {item.icon && (
                <div className="d-inline-block item-icon-wrapper">
                  <Svg src={require('../../images/icons/' + item.icon)} />
                </div>
              )}
              {item.title && item.title}
            </Link>
          )
        }
      </li>
    );
  }
}

CustomNavItem.propTypes = {
  /**
   * The item object.
   */
  item: PropTypes.object
};

export default CustomNavItem;
